(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("hanzi-tsconv", [], factory);
	else if(typeof exports === 'object')
		exports["hanzi-tsconv"] = factory();
	else
		root["hanzi-tsconv"] = factory();
})(window, function() {
return 